import SurfaceActionsStore from './schema/SurfaceActionsStore';
import { createStore } from 'satcheljs';

const initialSurfaceActionsStore: SurfaceActionsStore = {
    isAddinObserverLoaded: false,
};
const store = createStore<SurfaceActionsStore>(
    'AddinsSurfaceActionsStore',
    initialSurfaceActionsStore
)();

export default store;
